import $ from "jquery";
import Toast from "bootstrap/js/dist/toast";

/** Maps flash / notify type strings to Bootstrap `text-bg-*` variants. */
function toastVariant(type) {
  const key = String(type || "info").toLowerCase();
  if (key === "notice") return "info";
  if (key === "alert" || key === "error") return "danger";
  if (["info", "success", "warning", "danger", "primary", "secondary"].includes(key)) {
    return key;
  }
  return "info";
}

/**
 * Shows a Bootstrap 5 toast (replaces legacy bootstrap-notify growl).
 * @param {string} message plain text
 * @param {object} settings optional: type, timer (ms, 0 = no autohide), allow_dismiss
 */
export function showFlashToast(message, settings = {}) {
  if (message == null) return;
  const text = String(message).trim();
  if (!text) return;

  const variant = toastVariant(settings.type);
  const timer =
    typeof settings.timer === "number" && settings.timer >= 0 ? settings.timer : 6000;
  const allowDismiss = settings.allow_dismiss !== false;

  let root = document.getElementById("toast-flash-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "toast-flash-root";
    root.className = "toast-container position-fixed top-0 end-0 p-3";
    root.setAttribute("aria-label", "Notifications");
    root.style.zIndex = "1080";
    document.body.appendChild(root);
  }

  const el = document.createElement("div");
  el.className = `toast align-items-center text-bg-${variant} border-0`;
  el.setAttribute("role", "alert");
  el.setAttribute("aria-live", "polite");
  el.setAttribute("aria-atomic", "true");

  const row = document.createElement("div");
  row.className = "d-flex";

  const body = document.createElement("div");
  body.className = "toast-body";
  body.textContent = text;
  row.appendChild(body);

  if (allowDismiss) {
    const close = document.createElement("button");
    close.type = "button";
    const closeWhite = variant !== "warning";
    close.className = closeWhite
      ? "btn-close btn-close-white me-2 m-auto"
      : "btn-close me-2 m-auto";
    close.setAttribute("data-bs-dismiss", "toast");
    close.setAttribute("aria-label", "Close");
    row.appendChild(close);
  }

  el.appendChild(row);
  root.appendChild(el);

  const toast = new Toast(el, {
    autohide: timer > 0,
    delay: timer > 0 ? timer : 5000,
  });

  el.addEventListener(
    "hidden.bs.toast",
    () => {
      el.remove();
    },
    { once: true }
  );

  toast.show();
}

const FlashMessages = function (custom_flash) {
  if ($.isEmptyObject(custom_flash)) {
    const viewFlash = document.getElementById("flash");
    if (viewFlash && viewFlash.dataset.message) {
      const message = viewFlash.dataset.message;
      const type = viewFlash.dataset.type || "info";
      showFlashToast(message, {
        type,
        timer: 20000,
        allow_dismiss: true,
      });
    }
  } else {
    const options = custom_flash.options || {};
    const settings = customFlashSettings.call(this, custom_flash.settings || {});
    showFlashToast(options.message, {
      type: settings.type,
      timer: settings.timer,
      allow_dismiss: settings.allow_dismiss,
    });
  }
};

const customFlashSettings = function (settings) {
  const merged = { ...defaultFlashSettings.call(this), ...settings };
  if (merged.type === "alert") merged.type = "danger";
  return merged;
};

const defaultFlashSettings = function () {
  return {
    type: "info",
    allow_dismiss: true,
    timer: 20000,
  };
};

export default FlashMessages;
